import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/app/(site)/careers/components/careers/careers.tsx");
